<template>
  <div class="listContent">
    <a-form :form="form" class="headForm" labelAlign="left">
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-item label="文件名">
            <a-input
              @pressEnter="
                () => getList({ current: 1, pageSize: pagination.pageSize })
              "
              v-decorator="['fileName']"
              placeholder="请输入名称"
            />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="状态">
            <a-select v-decorator="['exportStatus']" placeholder="请选择">
              <a-select-option value="failure">失败</a-select-option>
              <a-select-option value="success">成功</a-select-option>
              <a-select-option value="processing">进行中</a-select-option>
              <a-select-option value="expired">已过期</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="10" class="submitBtnBox">
          <a-button
            type="primary"
            class="btnMar"
            @click="
              () => getList({ current: 1, pageSize: pagination.pageSize })
            "
          >
            查询
          </a-button>
          <a-button class="" @click="resetFields"> 清空 </a-button>
        </a-col>
      </a-row>
    </a-form>

    <div class="tableBox" ref="listRef">
      <div style="margin: 0 0 10px 0">
        <a-button @click="batchDownLoad" :disabled="!selectedRows.length">
          批量下载
        </a-button>
      </div>
      <a-table
        :row-selection="rowSelection"
        :rowClassName="rowClassName"
        :columns="columns"
        ref="listRef"
        :scroll="{ y, x: 100 }"
        :data-source="list"
        :pagination="pagination"
        row-key="id"
      >
        <template slot="exportStatus" slot-scope="text">
          <span v-if="text == 'failure'" style="color: red">失败</span>
          <span v-if="text == 'success'" style="color: #02830f">成功</span>
          <span v-if="text == 'processing'" style="color: #f59a23">进行中</span>
          <span v-if="text == 'expired'" style="color: #929292">已过期</span>
        </template>
        <template slot="x" slot-scope="t, record">
          <a
            v-if="record.exportStatus === 'success'"
            @click="exportData(record)"
            >下载</a
          >
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>
const columns = [
  {
    title: '文件名',
    dataIndex: 'fileName',
    width: 120,
    ellipsis: true,
  },
  {
    title: 'ID',
    dataIndex: 'id',
    width: 140,
    ellipsis: true,
  },
  {
    title: '状态',
    dataIndex: 'exportStatus',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'exportStatus' },
  },
  {
    title: '描述',
    dataIndex: 'params',
    width: 170,
    ellipsis: true,
  },
  {
    title: '创建人',
    dataIndex: 'createUserName',
    width: 100,
    ellipsis: true,
  },
  {
    title: '创建日期',
    dataIndex: 'createTime',
    width: 170,
    ellipsis: true,
  },
  {
    title: '操作',
    dataIndex: 'x',
    width: 80,
    scopedSlots: { customRender: 'x' },
  },
];
import { fileDownload } from '@/Utils/axios.js';
import api from './api'
export default {
  data() {
    return {
      y: 500,
      form: this.$form.createForm(this),
      pagination: {
        total: 0,
        pageSize: 20,
        current: 1,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.pagination.pageSize = pageSize
          this.getList()
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this.getList({ current: 1, pageSize })
        } //每页多少条
      },
      columns,
      list: [],
      // 多选
      selectedRowKeys: [],
      selectedRows: [],
    }
  },
  created() {
    this.getList()
  },
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          let arr = [...this.selectedRows, ...selectedRows]
          this.selectedRows = this.selectedRowKeys.map(i => {
            return arr.filter(item => item.id === i)[0]
          })
        },
        selectedRowKeys: this.selectedRowKeys,
        getCheckboxProps: record => ({
          props: {
            disabled: record.exportStatus != 'success', // Column configuration not to be checked
          },
        }),
      }
    },
    //  定义表头数据
    titleArr() {
      let arr = []
      this.columns.forEach((item) => {
        if (item.dataIndex != 'x') {
          arr.push(item.title)
        }
      })
      return arr
    }
  },

  mounted() {
    // this.y = this.$refs.listRef.$el.offsetHeight - 180
    this.y = this.$refs.listRef.offsetHeight - 180
  },
  methods: {
    rowClassName(record) {
      return record.isDownload ? 'downloadStyle' : ''
    },
    resetFields() {
      this.form.resetFields()
    },
    async getList(pagination) {
      let { current, pageSize } = pagination || this.pagination
      this.form.validateFields(async (err, values) => {
        let params = {
          lastDays: 7,
          current,
          size: pageSize,
          ...values
        }
        let res = await api.getList(params)
        let { success, data } = res;
        if (success) {
          let { records, current = 1, total = 0 } = data;
          this.pagination.current = current
          this.pagination.total = total
          this.list = records || []
        }
      })
    },
    exportData(record) {
      record.isDownload = true
      this.list = [...this.list]
      // window.open(record.fileUrl)
      fileDownload(record.fileUrl)
    },
    createIFrame(url, triggerDelay, removeDelay) {
      //动态添加iframe，设置src，然后删除
      setTimeout(function () {
        var frame = document.createElement("iframe");
        frame.src = url;
        frame.style.display = "none";
        document.body.appendChild(frame);

        setTimeout(function () {
          frame.remove();
        }, removeDelay);
      }, triggerDelay);
    },

    batchDownLoad() {
      // let triggerDelay = 100;
      // let removeDelay = 1000;
      this.selectedRows.forEach((el) => {
        // this.createIFrame(el.fileUrl, index * triggerDelay, removeDelay);
        fileDownload(el.fileUrl)
      })
    },

  }
}
</script>
<style lang="scss">
.downloadStyle {
  background: rgba(86, 204, 242, 0.12);
}
</style>

<style lang="scss" scoped>
.listContent {
  height: calc(100% - 41px);
  border-radius: 5px;
  .title_class {
    background-color: #fff;
    margin-bottom: 21px;
    border-radius: 5px;
    padding: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .title_search_class {
      display: flex;
      flex-wrap: wrap;
      flex: 2;
      .search_change_class {
        display: flex;
        align-items: center;
        margin: 0 10px 10px 0;
        .text_class {
          width: 100px;
        }
      }
    }
    .title_btn_class {
      flex: 0.6;
      .search_class {
        margin-right: 10px;
      }
    }
  }
  .content_class {
    background-color: #fff;
    border-radius: 5px;
    // padding: 20px;
    height: calc(100% - 80px);
  }
}
.tableBox {
  height: calc(100% - 60px);
}
</style>